<p-button
    [label]="'users.detail.delete' | translate"
    icon="pi pi-trash"
    severity="danger"
    [outlined]="true"
    [loading]="saving()"
    [attr.data-test]="testId()"
    (onClick)="onDelete()"
/>
